export function SettingsIcon() {
    return (
        <svg x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
            <path d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"></path>
        </svg>
    )
}

export function EyeIcon() {
    return (
        <svg fill="#000000" version="1.1" id="Capa_1" viewBox="0 0 442.04 442.04">
            <g>
                <g>
                    <path
                        d="M221.02,341.304c-49.708,0-103.206-19.44-154.71-56.22C27.808,257.59,4.044,230.351,3.051,229.203
                c-4.068-4.697-4.068-11.669,0-16.367c0.993-1.146,24.756-28.387,63.259-55.881c51.505-36.777,105.003-56.219,154.71-56.219
                c49.708,0,103.207,19.441,154.71,56.219c38.502,27.494,62.266,54.734,63.259,55.881c4.068,4.697,4.068,11.669,0,16.367
                c-0.993,1.146-24.756,28.387-63.259,55.881C324.227,321.863,270.729,341.304,221.02,341.304z M29.638,221.021
                c9.61,9.799,27.747,27.03,51.694,44.071c32.83,23.361,83.714,51.212,139.688,51.212s106.859-27.851,139.688-51.212
                c23.944-17.038,42.082-34.271,51.694-44.071c-9.609-9.799-27.747-27.03-51.694-44.071
                c-32.829-23.362-83.714-51.212-139.688-51.212s-106.858,27.85-139.688,51.212C57.388,193.988,39.25,211.219,29.638,221.021z"
                    />
                </g>
                <g>
                    <path
                        d="M221.02,298.521c-42.734,0-77.5-34.767-77.5-77.5c0-42.733,34.766-77.5,77.5-77.5c18.794,0,36.924,6.814,51.048,19.188
                c5.193,4.549,5.715,12.446,1.166,17.639c-4.549,5.193-12.447,5.714-17.639,1.166c-9.564-8.379-21.844-12.993-34.576-12.993
                c-28.949,0-52.5,23.552-52.5,52.5s23.551,52.5,52.5,52.5c28.95,0,52.5-23.552,52.5-52.5c0-6.903,5.597-12.5,12.5-12.5
                s12.5,5.597,12.5,12.5C298.521,263.754,263.754,298.521,221.02,298.521z"
                    />
                </g>
                <g>
                    <path d="M221.02,246.021c-13.785,0-25-11.215-25-25s11.215-25,25-25c13.786,0,25,11.215,25,25S234.806,246.021,221.02,246.021z" />
                </g>
            </g>
        </svg>
    )
}
export function TaskIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.4663 6.12625H20.9999V5.07936C20.9999 4.48318 20.5462 4 19.9864 4H12.0132C11.4534 4 10.9998 4.48318 10.9998 5.07936V6.12625H8.53373C7.13661 6.12625 6 7.33674 6 8.82465V25.3016C6 26.7895 7.13661 28 8.53373 28H23.4663C24.8634 28 26 26.7895 26 25.3016V8.82465C26 7.33674 24.8632 6.12625 23.4663 6.12625ZM18.9729 6.15872V8.25271H13.0265C13.0265 7.53532 13.0265 6.94273 13.0265 6.15872H18.9729ZM23.973 25.3016C23.973 25.5993 23.7456 25.8413 23.4663 25.8413H8.53373C8.25422 25.8413 8.02698 25.5993 8.02698 25.3016V8.82465C8.02698 8.52719 8.25422 8.28497 8.53373 8.28497H10.9996V9.33207C10.9996 9.92825 11.4534 10.4114 12.013 10.4114H19.9864C20.546 10.4114 20.9999 9.92825 20.9999 9.33207V8.28497H23.4663C23.7456 8.28497 23.973 8.52719 23.973 8.82465V25.3016ZM20.7027 14.2868C21.0986 14.7084 21.0986 15.3919 20.7027 15.8133L15.3768 21.4854C14.9811 21.907 14.3393 21.907 13.9434 21.4854L11.2967 18.6666C10.901 18.2452 10.901 17.5617 11.2967 17.1401C11.6926 16.7187 12.3341 16.7187 12.73 17.1401L14.6602 19.1957L19.2694 14.287C19.6653 13.8654 20.3068 13.8654 20.7027 14.2868Z"></path>
        </svg>
    )
}
export function TrainingIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M20 8.4c0-.1 0-.2-.1-.3l-.3-.3L10.3 3c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1L.4 7.8c-.1 0-.2.1-.3.2-.1.1-.1.2-.1.4 0 .1 0 .2.1.4.1 0 .2.1.3.2l2.9 1.5v3.1c-.4.2-.8.4-1 .8-.3.4-.3.8-.3 1.2.1.4.3.8.7 1.1.3.3.8.4 1.2.4s.9-.2 1.2-.4c.3-.3.6-.7.7-1.1.1-.4 0-.9-.2-1.2-.2-.4-.6-.7-1-.8v-2.4l5.1 2.6c.1 0 .1 0 .2.1h.3c.1 0 .1 0 .2-.1l5.1-2.6v.8c0 .3-.1.7-.3 1-.7 1.1-2.4 2.4-5.1 2.4-.9 0-1.8-.1-2.7-.4h-.2c-.1 0-.3 0-.4.1-.1.1-.2.2-.2.3v.2c0 .1.1.3.1.4.1.1.2.2.4.2 1 .3 2 .4 3 .4 1.8 0 3.5-.5 4.9-1.6.5-.4 1-.8 1.3-1.4.3-.5.5-1.1.6-1.8v-1.6L19.6 9c.1-.1.2-.1.3-.2.1-.2.1-.3.1-.4zM4.3 15.7c0 .1-.1.1-.2.1h-.4c-.1 0-.1-.1-.2-.1-.1-.1-.2-.2-.2-.4 0-.1.1-.3.2-.4 0-.1.1-.1.2-.1h.4c.1 0 .1.1.2.1.1.1.2.3.2.4-.1.1-.1.3-.2.4zM10.2 9c.1 0 .3-.1.3-.2.1-.1.1-.2.1-.4v-.2c0-.1-.1-.3-.2-.3-.1-.1-.3-.1-.4-.2h-.1L4 9.4l-1.9-1L10 4.3l7.9 4.1-7.9 4-4.3-2.2L10.2 9z"></path>
        </svg>
    )
}
export function GuideIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
                d="M8.78422 24.25H23.2158C24.751 24.25 26 22.9883 26 21.4375V6.8125C26 5.26169 24.751 4 23.2158 4H8.78422C7.249 4 6 5.26169 6 6.8125V25.1875C6 26.7383 7.249 28 8.78422 28H22.2877H23.2158C24.751 28 26 26.7383 26 25.1875V25.1852C25.2239 25.775 24.2596 26.125 23.2158 26.125H22.2877H8.78422C8.27248 26.125 7.85615 25.7044 7.85615 25.1875C7.85615 24.6706 8.27248 24.25 8.78422 24.25ZM7.85615 6.8125C7.85615 6.29556 8.27248 5.875 8.78422 5.875H23.2158C23.7275 5.875 24.1439 6.29556 24.1439 6.8125V21.4375C24.1439 21.9544 23.7275 22.375 23.2158 22.375H8.78422C8.45898 22.375 8.14654 22.4316 7.85615 22.5356V6.8125ZM14.4455 11.9022H12.5893C12.5893 10.9404 12.9974 10.0198 13.709 9.37637C14.4298 8.72444 15.3996 8.41281 16.3697 8.52166C17.9239 8.69589 19.1755 9.95683 19.3456 11.52C19.5007 12.9456 18.673 13.9686 18.037 14.6141C17.8733 14.7802 17.7222 14.9258 17.5889 15.0543C16.9824 15.6385 16.9052 15.7368 16.9052 16.1404V16.1875H15.049V16.1404C15.049 14.9101 15.6324 14.3481 16.3079 13.6973C16.4391 13.5709 16.5748 13.4402 16.7215 13.2913C17.3209 12.683 17.5539 12.2146 17.5006 11.7248C17.4246 11.0268 16.863 10.4635 16.1651 10.3852C15.7128 10.3347 15.28 10.4723 14.947 10.7734C14.6236 11.0658 14.4455 11.4667 14.4455 11.9022ZM15.0487 17.5938H16.9049V19.4688H15.0487V17.5938Z"
                fill="#06A0C7"
            ></path>
        </svg>
    )
}
export function TileIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.61627 0H0.692403C0.309993 0 0 0.309993 0 0.692403V7.61631C0 7.99872 0.309993 8.30871 0.692403 8.30871H7.61631C7.99872 8.30871 8.30871 7.99872 8.30871 7.61631V0.692403C8.30867 0.309993 7.99868 0 7.61627 0ZM6.92391 6.92391H1.38477V1.38477H6.92387V6.92391H6.92391Z"
                fill="currentColor"
            ></path>
            <path
                d="M17.3077 0H10.3838C10.0014 0 9.69141 0.309993 9.69141 0.692403V7.61631C9.69141 7.99872 10.0014 8.30871 10.3838 8.30871H17.3077C17.6901 8.30871 18.0001 7.99872 18.0001 7.61631V0.692403C18.0001 0.309993 17.6901 0 17.3077 0ZM16.6153 6.92391H11.0762V1.38477H16.6153V6.92391Z"
                fill="currentColor"
            ></path>
            <path
                d="M7.61627 9.69141H0.692403C0.309993 9.69141 0 10.0014 0 10.3838V17.3077C0 17.6901 0.309993 18.0001 0.692403 18.0001H7.61631C7.99872 18.0001 8.30871 17.6901 8.30871 17.3077V10.3838C8.30867 10.0014 7.99868 9.69141 7.61627 9.69141ZM6.92391 16.6153H1.38477V11.0762H6.92387V16.6153H6.92391Z"
                fill="currentColor"
            ></path>
            <path
                d="M17.3077 9.69141H10.3838C10.0014 9.69141 9.69141 10.0014 9.69141 10.3838V17.3077C9.69141 17.6901 10.0014 18.0001 10.3838 18.0001H17.3077C17.6901 18.0001 18.0001 17.6901 18.0001 17.3077V10.3838C18.0001 10.0014 17.6901 9.69141 17.3077 9.69141ZM16.6153 16.6153H11.0762V11.0762H16.6153V16.6153Z"
                fill="currentColor"
            ></path>
        </svg>
    )
}
export function RowIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                id="Vector"
                d="M15.8906 0H2.10938C0.946266 0 0 0.946266 0 2.10938V15.8906C0 17.0537 0.946266 18 2.10938 18H15.8906C17.0537 18 18 17.0537 18 15.8906V2.10938C18 0.946266 17.0537 0 15.8906 0ZM4.21875 16.5938H2.10938C1.72167 16.5938 1.40625 16.2783 1.40625 15.8906V5.625H4.21875V16.5938ZM4.21875 4.21875H1.40625V2.10938C1.40625 1.72167 1.72167 1.40625 2.10938 1.40625H4.21875V4.21875ZM16.5938 15.8906C16.5938 16.2783 16.2783 16.5938 15.8906 16.5938H5.625V5.625H16.5938V15.8906ZM16.5938 4.21875H5.625V1.40625H15.8906C16.2783 1.40625 16.5938 1.72167 16.5938 2.10938V4.21875Z"
                fill="currentColor"
            ></path>
        </svg>
    )
}
export function AllIcon() {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 188 184"
            enable-background="new 0 0 188 184"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M142.000000,1.000002 
   C157.657364,1.000000 173.314728,1.000000 188.979065,0.999998 
   C188.986053,62.287605 188.986053,123.575211 188.986053,184.931412 
   C126.416336,184.931412 63.832581,184.931412 1.124410,184.931412 
   C1.124410,123.786255 1.124410,62.572170 1.124410,1.000000 
   C45.353584,1.000000 89.708138,1.000000 134.688873,1.335115 
   C123.048645,13.835272 110.737770,25.955975 98.535042,38.184586 
   C92.675301,44.056751 92.759438,47.147469 98.483551,52.866234 
   C109.906601,64.278595 121.321495,75.699150 132.761581,87.094429 
   C136.842148,91.159012 140.206329,91.185188 144.262009,87.137085 
   C155.454361,75.965622 166.610443,64.757828 177.776199,53.559761 
   C183.850128,47.468277 183.916168,43.701630 177.915634,37.653858 
   C169.709518,29.383142 161.403976,21.210892 153.218155,12.920321 
   C149.385666,9.038793 145.733749,4.979001 142.000000,1.000002 
M7.050240,23.556210 
   C7.054665,40.219822 7.027044,56.883541 7.080246,73.546997 
   C7.099856,79.688995 9.597746,82.783485 15.013864,82.818062 
   C34.009163,82.939316 53.006161,82.927879 72.001526,82.808868 
   C76.625214,82.779900 79.821312,79.738853 79.841354,75.505363 
   C79.935234,55.676197 79.931839,35.846207 79.858704,16.016899 
   C79.842819,11.710531 77.484245,9.069702 73.074638,9.051574 
   C53.578636,8.971422 34.081642,8.943152 14.586128,9.069389 
   C9.948047,9.099422 7.117406,12.419817 7.039965,17.082592 
   C7.009532,18.914978 7.044836,20.748459 7.050240,23.556210 
M102.128311,145.499969 
   C102.127441,153.158234 102.115349,160.816528 102.129097,168.474777 
   C102.141113,175.164764 103.721703,176.876007 110.220062,176.889572 
   C129.032654,176.928818 147.845444,176.925858 166.658035,176.881180 
   C172.851273,176.866486 174.764984,175.027527 174.789978,168.913925 
   C174.866898,150.101486 174.876785,131.288589 174.843689,112.475998 
   C174.832718,106.238815 172.699844,104.092270 166.435669,104.073036 
   C147.789627,104.015785 129.143173,104.011215 110.497200,104.076569 
   C104.268677,104.098404 102.164345,106.301025 102.139038,112.534966 
   C102.095779,123.189796 102.127869,133.844940 102.128311,145.499969 
M7.043938,136.500000 
   C7.061101,147.328781 7.029970,158.157944 7.114573,168.986191 
   C7.161092,174.940048 9.036674,176.891418 14.752476,176.904007 
   C33.910961,176.946182 53.069721,176.944946 72.228149,176.885559 
   C78.091721,176.867386 79.862885,174.992554 79.874069,168.995071 
   C79.909172,150.169678 79.916710,131.344162 79.882141,112.518791 
   C79.870262,106.050323 78.029869,104.087753 71.639008,104.063118 
   C52.813889,103.990540 33.988197,104.011742 15.162936,104.067078 
   C9.989478,104.082275 7.169211,106.868050 7.100778,112.010178 
   C6.996591,119.838974 7.056254,127.669952 7.043938,136.500000 
z"
            />
            <path
                fill="#4F5769"
                opacity="1.000000"
                stroke="none"
                d="
M141.562500,1.000002 
   C145.733749,4.979001 149.385666,9.038793 153.218155,12.920321 
   C161.403976,21.210892 169.709518,29.383142 177.915634,37.653858 
   C183.916168,43.701630 183.850128,47.468277 177.776199,53.559761 
   C166.610443,64.757828 155.454361,75.965622 144.262009,87.137085 
   C140.206329,91.185188 136.842148,91.159012 132.761581,87.094429 
   C121.321495,75.699150 109.906601,64.278595 98.483551,52.866234 
   C92.759438,47.147469 92.675301,44.056751 98.535042,38.184586 
   C110.737770,25.955975 123.048645,13.835272 135.157532,1.335115 
   C137.041672,1.000000 139.083328,1.000000 141.562500,1.000002 
M129.885437,62.613277 
   C132.430069,65.632477 134.974686,68.651672 136.829315,70.852188 
   C146.205856,61.785431 154.509613,53.756012 162.035797,46.478474 
   C153.984100,38.057842 145.902100,29.605503 139.452637,22.860521 
   C130.747787,30.540417 122.080948,38.186779 113.029213,46.172718 
   C118.688721,51.685307 124.039459,56.897144 129.885437,62.613277 
z"
            />
            <path
                fill="#4F576A"
                opacity="1.000000"
                stroke="none"
                d="
M7.050221,23.068825 
   C7.044836,20.748459 7.009532,18.914978 7.039965,17.082592 
   C7.117406,12.419817 9.948047,9.099422 14.586128,9.069389 
   C34.081642,8.943152 53.578636,8.971422 73.074638,9.051574 
   C77.484245,9.069702 79.842819,11.710531 79.858704,16.016899 
   C79.931839,35.846207 79.935234,55.676197 79.841354,75.505363 
   C79.821312,79.738853 76.625214,82.779900 72.001526,82.808868 
   C53.006161,82.927879 34.009163,82.939316 15.013864,82.818062 
   C9.597746,82.783485 7.099856,79.688995 7.080246,73.546997 
   C7.027044,56.883541 7.054665,40.219822 7.050221,23.068825 
M65.154221,54.483196 
   C65.127190,45.654457 65.017303,36.824764 65.119370,27.997519 
   C65.153763,25.023336 64.173172,23.870411 61.098518,23.904263 
   C49.535461,24.031574 37.969368,24.033455 26.406204,23.912027 
   C22.786390,23.874014 21.872149,25.585348 21.899527,28.827211 
   C21.995188,40.153793 22.017576,51.482689 21.881075,62.808453 
   C21.842247,66.029915 22.914743,67.202003 26.189926,67.145370 
   C35.182446,66.989861 44.179733,67.115852 53.175140,67.120407 
   C65.075089,67.126427 65.075089,67.122330 65.154221,54.483196 
z"
            />
            <path
                fill="#4F576A"
                opacity="1.000000"
                stroke="none"
                d="
M102.128311,144.999954 
   C102.127869,133.844940 102.095779,123.189796 102.139038,112.534966 
   C102.164345,106.301025 104.268677,104.098404 110.497200,104.076569 
   C129.143173,104.011215 147.789627,104.015785 166.435669,104.073036 
   C172.699844,104.092270 174.832718,106.238815 174.843689,112.475998 
   C174.876785,131.288589 174.866898,150.101486 174.789978,168.913925 
   C174.764984,175.027527 172.851273,176.866486 166.658035,176.881180 
   C147.845444,176.925858 129.032654,176.928818 110.220062,176.889572 
   C103.721703,176.876007 102.141113,175.164764 102.129097,168.474777 
   C102.115349,160.816528 102.127441,153.158234 102.128311,144.999954 
M144.494934,118.968140 
   C135.426636,118.968140 126.358330,118.968140 116.958458,118.968140 
   C116.958458,132.920227 116.995819,145.890274 116.929451,158.859787 
   C116.914772,161.728531 118.549500,162.017593 120.791664,162.011276 
   C132.608826,161.978027 144.427170,161.922241 156.242783,162.065598 
   C159.479019,162.104843 160.154602,160.638504 160.089462,157.832535 
   C159.969757,152.675934 160.082184,147.514099 160.086166,142.354446 
   C160.092056,134.756531 160.087692,127.158615 160.087692,118.977486 
   C154.726807,118.977486 150.109589,118.977486 144.494934,118.968140 
z"
            />
            <path
                fill="#4F576A"
                opacity="1.000000"
                stroke="none"
                d="
M7.045136,136.000000 
   C7.056254,127.669952 6.996591,119.838974 7.100778,112.010178 
   C7.169211,106.868050 9.989478,104.082275 15.162936,104.067078 
   C33.988197,104.011742 52.813889,103.990540 71.639008,104.063118 
   C78.029869,104.087753 79.870262,106.050323 79.882141,112.518791 
   C79.916710,131.344162 79.909172,150.169678 79.874069,168.995071 
   C79.862885,174.992554 78.091721,176.867386 72.228149,176.885559 
   C53.069721,176.944946 33.910961,176.946182 14.752476,176.904007 
   C9.036674,176.891418 7.161092,174.940048 7.114573,168.986191 
   C7.029970,158.157944 7.061101,147.328781 7.045136,136.000000 
M56.430969,162.008484 
   C57.263443,162.014984 58.119087,161.897522 58.924625,162.048111 
   C64.185547,163.031662 65.445732,160.562042 65.250763,155.701218 
   C64.917389,147.389740 65.154755,139.055374 65.153015,130.730621 
   C65.152229,126.975449 65.152885,123.220268 65.152885,119.334061 
   C50.303459,119.334061 36.416599,119.334061 22.261902,119.334061 
   C22.261902,133.605896 22.261902,147.487549 22.261902,162.005463 
   C33.568195,162.005463 44.507271,162.005463 56.430969,162.008484 
z"
            />
        </svg>
    )
}
export function CompareIcon() {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 148 160"
            enable-background="new 0 0 148 160"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M82.000000,161.000000 
	C54.688461,161.000000 27.876921,161.000000 1.032690,161.000000 
	C1.032690,107.731796 1.032690,54.463562 1.032690,1.097664 
	C50.227982,1.097664 99.456223,1.097664 148.842224,1.097664 
	C148.842224,54.332962 148.842224,107.666435 148.842224,161.000000 
	C126.797249,161.000000 104.648628,161.000000 82.000000,161.000000 
M64.945839,138.011368 
	C65.971695,141.903366 68.624702,143.598129 72.424751,142.785645 
	C76.081062,142.003906 77.086220,139.207352 77.283798,135.623398 
	C77.375130,133.966782 78.661293,131.830460 80.062378,130.892899 
	C84.443169,127.961426 84.859024,122.786140 80.134018,120.583626 
	C77.323212,119.273392 77.113785,117.634384 77.117195,115.199280 
	C77.150993,91.038467 77.158394,66.877548 77.106781,42.716805 
	C77.101425,40.210442 77.433929,38.624008 80.212357,37.380871 
	C84.256126,35.571590 84.830772,29.846033 81.106346,28.153507 
	C77.361374,26.451653 77.076042,24.149622 77.042274,20.802015 
	C77.004158,17.022995 74.539917,15.001145 70.867043,15.077965 
	C67.187263,15.154929 65.084908,17.284744 64.875458,21.070019 
	C64.777702,22.836727 64.685371,24.603735 64.603920,26.122007 
	C63.787277,26.475653 63.490143,26.715670 63.191540,26.717516 
	C53.030499,26.780434 42.868465,26.753883 32.708397,26.883156 
	C22.574661,27.012094 15.039879,34.547646 15.014398,44.629856 
	C14.956702,67.457558 14.965305,90.285561 15.009914,113.113312 
	C15.030232,123.510757 22.517462,131.015213 32.951363,131.118713 
	C41.615093,131.204666 50.293915,131.427856 58.939674,131.024704 
	C63.859268,130.795303 65.640068,132.465607 64.945839,138.011368 
M107.903076,38.182369 
	C112.860825,38.697899 114.704155,41.561413 114.361359,46.364544 
	C114.234856,48.137142 114.116066,50.486343 115.094971,51.629795 
	C116.650383,53.446655 119.113853,55.491753 121.223328,55.524925 
	C123.061462,55.553829 125.908806,53.305214 126.629608,51.420280 
	C129.284302,44.478081 126.170448,35.538807 120.355713,30.728750 
	C114.172768,25.614098 106.933403,26.532726 99.923065,27.346333 
	C98.427818,27.519869 96.210907,30.976082 96.320999,32.799557 
	C96.430336,34.610588 98.755760,36.862396 100.662361,37.821033 
	C102.402885,38.696175 104.883949,38.098495 107.903076,38.182369 
M97.361313,129.213120 
	C97.878212,129.626419 98.350288,130.319641 98.918793,130.410690 
	C106.523903,131.628708 114.015633,132.380447 120.673416,127.010559 
	C127.264412,121.694542 127.771477,114.477303 126.679771,107.110886 
	C126.402252,105.238297 123.147896,102.484741 121.295685,102.511513 
	C119.115486,102.543037 116.435974,104.773308 114.990891,106.782326 
	C113.919571,108.271729 114.289558,110.934608 114.342339,113.066711 
	C114.444870,117.208969 112.207664,119.173180 108.451561,119.709282 
	C106.658195,119.965240 104.807343,119.804924 102.983513,119.863495 
	C97.071754,120.053375 95.160423,122.778069 97.361313,129.213120 
M127.001892,73.106911 
	C126.443687,69.183769 124.095200,66.987015 120.230270,67.386986 
	C116.138657,67.810410 114.291206,70.694115 114.302864,74.723145 
	C114.312958,78.210686 114.130783,81.730202 114.535706,85.176590 
	C114.964722,88.828011 117.588448,90.811264 121.137115,90.649384 
	C124.745979,90.484756 126.880783,88.204063 126.987495,84.467567 
	C127.087135,80.978600 127.013077,77.484680 127.001892,73.106911 
z"
            />
            <path
                fill="#818A9E"
                opacity="1.000000"
                stroke="none"
                d="
M64.911949,137.591141 
	C65.640068,132.465607 63.859268,130.795303 58.939674,131.024704 
	C50.293915,131.427856 41.615093,131.204666 32.951363,131.118713 
	C22.517462,131.015213 15.030232,123.510757 15.009914,113.113312 
	C14.965305,90.285561 14.956702,67.457558 15.014398,44.629856 
	C15.039879,34.547646 22.574661,27.012094 32.708397,26.883156 
	C42.868465,26.753883 53.030499,26.780434 63.191540,26.717516 
	C63.490143,26.715670 63.787277,26.475653 64.603920,26.122007 
	C64.685371,24.603735 64.777702,22.836727 64.875458,21.070019 
	C65.084908,17.284744 67.187263,15.154929 70.867043,15.077965 
	C74.539917,15.001145 77.004158,17.022995 77.042274,20.802015 
	C77.076042,24.149622 77.361374,26.451653 81.106346,28.153507 
	C84.830772,29.846033 84.256126,35.571590 80.212357,37.380871 
	C77.433929,38.624008 77.101425,40.210442 77.106781,42.716805 
	C77.158394,66.877548 77.150993,91.038467 77.117195,115.199280 
	C77.113785,117.634384 77.323212,119.273392 80.134018,120.583626 
	C84.859024,122.786140 84.443169,127.961426 80.062378,130.892899 
	C78.661293,131.830460 77.375130,133.966782 77.283798,135.623398 
	C77.086220,139.207352 76.081062,142.003906 72.424751,142.785645 
	C68.624702,143.598129 65.971695,141.903366 64.911949,137.591141 
M27.683022,96.499657 
	C27.683411,101.823799 27.634348,107.148544 27.698317,112.471924 
	C27.760311,117.631126 29.746887,119.758522 34.916924,119.831207 
	C43.566956,119.952805 52.221577,119.768997 60.870777,119.917290 
	C63.890285,119.969063 64.928696,118.967247 64.917145,115.907089 
	C64.824135,91.283257 64.821648,66.658752 64.919037,42.034954 
	C64.931412,38.907104 63.760643,38.037991 60.812901,38.085953 
	C52.329788,38.223976 43.842289,38.068703 35.357853,38.157108 
	C29.619440,38.216896 27.704334,40.242966 27.693748,46.085037 
	C27.663906,62.556564 27.682817,79.028183 27.683022,96.499657 
z"
            />
            <path
                fill="#828B9F"
                opacity="1.000000"
                stroke="none"
                d="
M107.470856,38.166145 
	C104.883949,38.098495 102.402885,38.696175 100.662361,37.821033 
	C98.755760,36.862396 96.430336,34.610588 96.320999,32.799557 
	C96.210907,30.976082 98.427818,27.519869 99.923065,27.346333 
	C106.933403,26.532726 114.172768,25.614098 120.355713,30.728750 
	C126.170448,35.538807 129.284302,44.478081 126.629608,51.420280 
	C125.908806,53.305214 123.061462,55.553829 121.223328,55.524925 
	C119.113853,55.491753 116.650383,53.446655 115.094971,51.629795 
	C114.116066,50.486343 114.234856,48.137142 114.361359,46.364544 
	C114.704155,41.561413 112.860825,38.697899 107.470856,38.166145 
z"
            />
            <path
                fill="#828B9F"
                opacity="1.000000"
                stroke="none"
                d="
M97.115005,128.886047 
	C95.160423,122.778069 97.071754,120.053375 102.983513,119.863495 
	C104.807343,119.804924 106.658195,119.965240 108.451561,119.709282 
	C112.207664,119.173180 114.444870,117.208969 114.342339,113.066711 
	C114.289558,110.934608 113.919571,108.271729 114.990891,106.782326 
	C116.435974,104.773308 119.115486,102.543037 121.295685,102.511513 
	C123.147896,102.484741 126.402252,105.238297 126.679771,107.110886 
	C127.771477,114.477303 127.264412,121.694542 120.673416,127.010559 
	C114.015633,132.380447 106.523903,131.628708 98.918793,130.410690 
	C98.350288,130.319641 97.878212,129.626419 97.115005,128.886047 
z"
            />
            <path
                fill="#858DA1"
                opacity="1.000000"
                stroke="none"
                d="
M127.008682,73.549927 
	C127.013077,77.484680 127.087135,80.978600 126.987495,84.467567 
	C126.880783,88.204063 124.745979,90.484756 121.137115,90.649384 
	C117.588448,90.811264 114.964722,88.828011 114.535706,85.176590 
	C114.130783,81.730202 114.312958,78.210686 114.302864,74.723145 
	C114.291206,70.694115 116.138657,67.810410 120.230270,67.386986 
	C124.095200,66.987015 126.443687,69.183769 127.008682,73.549927 
z"
            />
            <path
                fill="#FDFEFE"
                opacity="1.000000"
                stroke="none"
                d="
M27.682766,95.999710 
	C27.682817,79.028183 27.663906,62.556564 27.693748,46.085037 
	C27.704334,40.242966 29.619440,38.216896 35.357853,38.157108 
	C43.842289,38.068703 52.329788,38.223976 60.812901,38.085953 
	C63.760643,38.037991 64.931412,38.907104 64.919037,42.034954 
	C64.821648,66.658752 64.824135,91.283257 64.917145,115.907089 
	C64.928696,118.967247 63.890285,119.969063 60.870777,119.917290 
	C52.221577,119.768997 43.566956,119.952805 34.916924,119.831207 
	C29.746887,119.758522 27.760311,117.631126 27.698317,112.471924 
	C27.634348,107.148544 27.683411,101.823799 27.682766,95.999710 
z"
            />
        </svg>
    )
}
export function DeleteIcon() {
    return (
        <svg
            fill="#98a8b7"
            height="200px"
            width="200px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 460.775 460.775"
        >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55 c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55 c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505 c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55 l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719 c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"></path>{' '}
            </g>
        </svg>
    )
}
export function CopiesIcon() {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 126 106"
            enable-background="new 0 0 126 106"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M81.000000,107.000000 
   C54.000000,107.000000 27.500000,107.000000 1.000000,107.000000 
   C1.000000,71.666664 1.000000,36.333332 1.000000,1.000000 
   C43.000000,1.000000 85.000000,1.000000 127.000000,1.000000 
   C127.000000,36.333332 127.000000,71.666664 127.000000,107.000000 
   C111.833336,107.000000 96.666664,107.000000 81.000000,107.000000 
M74.504837,97.902290 
   C83.336021,97.900055 92.169395,98.020554 100.997826,97.863602 
   C111.338409,97.679756 120.697296,90.975883 120.171806,78.378441 
   C119.491814,62.077415 119.583710,45.711643 120.160446,29.402645 
   C120.520370,19.224707 112.540009,11.415029 102.987083,11.131927 
   C89.003006,10.717507 74.988304,10.716125 61.004353,11.132781 
   C51.464943,11.417011 43.490795,19.215681 43.838505,29.411095 
   C44.411785,46.220818 43.979408,63.064354 44.000061,79.893600 
   C44.011181,88.956245 48.686752,95.222908 57.626740,96.919632 
   C62.796329,97.900764 68.206024,97.616753 74.504837,97.902290 
M24.993374,36.506104 
   C24.993374,41.834698 24.993223,47.163296 24.993408,52.491890 
   C24.993803,63.815189 25.024582,75.138611 24.978842,86.461723 
   C24.962345,90.545731 26.640539,93.270050 30.828560,93.775505 
   C34.496273,94.218170 37.448185,91.204185 37.873188,86.902420 
   C37.970993,85.912468 37.902462,84.905617 37.902508,83.906548 
   C37.903400,65.089890 37.903854,46.273235 37.901218,27.456579 
   C37.901054,26.291304 38.008789,25.105751 37.836201,23.964430 
   C37.235676,19.993084 35.252579,17.547171 30.840521,17.895905 
   C26.729647,18.220833 25.014935,20.617800 24.999540,24.519320 
   C24.985086,28.182684 24.994469,31.846142 24.993374,36.506104 
M18.903234,67.494453 
   C18.901104,55.363743 18.980127,43.232197 18.855831,31.102736 
   C18.807913,26.426592 16.341244,24.014360 12.265191,24.005585 
   C8.226042,23.996887 6.027000,26.422556 6.012671,31.255783 
   C5.964393,47.540714 6.007371,63.825897 5.985089,80.110939 
   C5.979509,84.188873 7.542328,86.851959 11.949377,87.092773 
   C16.161371,87.322922 18.607872,85.096527 18.845572,80.453339 
   C19.049219,76.475349 18.897579,72.479179 18.903234,67.494453 
z"
            />
            <path
                fill="#9BA3B8"
                opacity="1.000000"
                stroke="none"
                d="
M74.006248,97.902206 
   C68.206024,97.616753 62.796329,97.900764 57.626740,96.919632 
   C48.686752,95.222908 44.011181,88.956245 44.000061,79.893600 
   C43.979408,63.064354 44.411785,46.220818 43.838505,29.411095 
   C43.490795,19.215681 51.464943,11.417011 61.004353,11.132781 
   C74.988304,10.716125 89.003006,10.717507 102.987083,11.131927 
   C112.540009,11.415029 120.520370,19.224707 120.160446,29.402645 
   C119.583710,45.711643 119.491814,62.077415 120.171806,78.378441 
   C120.697296,90.975883 111.338409,97.679756 100.997826,97.863602 
   C92.169395,98.020554 83.336021,97.900055 74.006248,97.902206 
M107.097656,71.478195 
   C107.097534,57.321735 107.122505,43.165207 107.084404,29.008848 
   C107.070015,23.662004 105.557320,21.977428 100.385826,21.937975 
   C88.062111,21.843954 75.737183,21.908527 63.412746,21.910219 
   C58.877323,21.910843 56.832829,24.073368 56.861259,28.710630 
   C56.966438,45.864296 56.978001,63.019547 56.852196,80.172935 
   C56.819180,84.674484 59.081547,86.774017 63.120537,86.823013 
   C75.776070,86.976524 88.436317,86.985703 101.091148,86.802742 
   C104.848732,86.748413 107.324730,84.749466 107.119804,80.459595 
   C106.992805,77.800941 107.097267,75.131233 107.097656,71.478195 
z"
            />
            <path
                fill="#9BA3B9"
                opacity="1.000000"
                stroke="none"
                d="
M24.993370,36.007832 
   C24.994469,31.846142 24.985086,28.182684 24.999540,24.519320 
   C25.014935,20.617800 26.729647,18.220833 30.840521,17.895905 
   C35.252579,17.547171 37.235676,19.993084 37.836201,23.964430 
   C38.008789,25.105751 37.901054,26.291304 37.901218,27.456579 
   C37.903854,46.273235 37.903400,65.089890 37.902508,83.906548 
   C37.902462,84.905617 37.970993,85.912468 37.873188,86.902420 
   C37.448185,91.204185 34.496273,94.218170 30.828560,93.775505 
   C26.640539,93.270050 24.962345,90.545731 24.978842,86.461723 
   C25.024582,75.138611 24.993803,63.815189 24.993408,52.491890 
   C24.993223,47.163296 24.993374,41.834698 24.993370,36.007832 
z"
            />
            <path
                fill="#9BA3B9"
                opacity="1.000000"
                stroke="none"
                d="
M18.903152,67.992752 
   C18.897579,72.479179 19.049219,76.475349 18.845572,80.453339 
   C18.607872,85.096527 16.161371,87.322922 11.949377,87.092773 
   C7.542328,86.851959 5.979509,84.188873 5.985089,80.110939 
   C6.007371,63.825897 5.964393,47.540714 6.012671,31.255783 
   C6.027000,26.422556 8.226042,23.996887 12.265191,24.005585 
   C16.341244,24.014360 18.807913,26.426592 18.855831,31.102736 
   C18.980127,43.232197 18.901104,55.363743 18.903152,67.992752 
z"
            />
            <path
                fill="#FFFFFF"
                opacity="1.000000"
                stroke="none"
                d="
M107.097748,71.972336 
   C107.097267,75.131233 106.992805,77.800941 107.119804,80.459595 
   C107.324730,84.749466 104.848732,86.748413 101.091148,86.802742 
   C88.436317,86.985703 75.776070,86.976524 63.120537,86.823013 
   C59.081547,86.774017 56.819180,84.674484 56.852196,80.172935 
   C56.978001,63.019547 56.966438,45.864296 56.861259,28.710630 
   C56.832829,24.073368 58.877323,21.910843 63.412746,21.910219 
   C75.737183,21.908527 88.062111,21.843954 100.385826,21.937975 
   C105.557320,21.977428 107.070015,23.662004 107.084404,29.008848 
   C107.122505,43.165207 107.097534,57.321735 107.097748,71.972336 
z"
            />
        </svg>
    )
}
export function StopIcon() {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 160 162"
            enable-background="new 0 0 160 162"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M91.000000,163.000000 
   C60.666672,163.000000 30.833340,163.000000 1.000008,163.000000 
   C1.000005,109.000008 1.000005,55.000019 1.000003,1.000023 
   C54.333317,1.000015 107.666634,1.000015 160.999969,1.000008 
   C160.999969,54.999981 160.999969,108.999962 160.999985,162.999969 
   C137.833328,163.000000 114.666664,163.000000 91.000000,163.000000 
M130.035553,123.419609 
   C131.004272,122.126099 131.977051,120.835625 132.941055,119.538620 
   C144.279999,104.282982 148.425705,87.000809 144.639313,68.645241 
   C139.926941,45.800888 126.193916,29.636280 104.346352,20.797049 
   C92.471390,15.992595 80.311493,14.619954 67.699120,17.681770 
   C52.602131,21.346764 40.065662,28.786272 30.339466,41.100876 
   C17.805334,56.970688 13.894565,74.736885 17.812061,94.352165 
   C20.836603,109.496338 28.768822,121.543327 40.727825,131.351151 
   C55.620998,143.565369 72.873283,146.822617 91.173714,144.732224 
   C106.439606,142.988464 119.021896,135.071884 130.035553,123.419609 
z"
            />
            <path
                fill="#FDFEFE"
                opacity="1.000000"
                stroke="none"
                d="
M129.791840,123.686111 
   C119.021896,135.071884 106.439606,142.988464 91.173714,144.732224 
   C72.873283,146.822617 55.620998,143.565369 40.727825,131.351151 
   C28.768822,121.543327 20.836603,109.496338 17.812061,94.352165 
   C13.894565,74.736885 17.805334,56.970688 30.339466,41.100876 
   C40.065662,28.786272 52.602131,21.346764 67.699120,17.681770 
   C80.311493,14.619954 92.471390,15.992595 104.346352,20.797049 
   C126.193916,29.636280 139.926941,45.800888 144.639313,68.645241 
   C148.425705,87.000809 144.279999,104.282982 132.941055,119.538620 
   C131.977051,120.835625 131.004272,122.126099 129.791840,123.686111 
M34.010811,61.811550 
   C32.673706,67.766212 30.124950,73.744881 30.242342,79.670731 
   C30.518391,93.605408 34.558128,106.418312 45.018940,116.592155 
   C54.867992,126.171013 66.650017,131.674500 80.166534,131.824142 
   C97.793114,132.019302 112.013954,124.215508 122.452477,109.993896 
   C128.732742,101.437576 131.621246,91.252625 131.665192,81.028648 
   C131.703873,72.026207 128.962433,63.232460 124.191719,54.925827 
   C113.093346,35.601696 88.351089,26.309092 66.798203,32.579544 
   C51.421928,37.053017 41.125401,46.984501 34.010811,61.811550 
z"
            />
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M34.181660,61.449093 
   C41.125401,46.984501 51.421928,37.053017 66.798203,32.579544 
   C88.351089,26.309092 113.093346,35.601696 124.191719,54.925827 
   C128.962433,63.232460 131.703873,72.026207 131.665192,81.028648 
   C131.621246,91.252625 128.732742,101.437576 122.452477,109.993896 
   C112.013954,124.215508 97.793114,132.019302 80.166534,131.824142 
   C66.650017,131.674500 54.867992,126.171013 45.018940,116.592155 
   C34.558128,106.418312 30.518391,93.605408 30.242342,79.670731 
   C30.124950,73.744881 32.673706,67.766212 34.181660,61.449093 
M100.995667,71.714188 
   C100.986076,63.301563 98.704948,61.013905 90.286629,61.003628 
   C83.474007,60.995312 76.659164,60.896263 69.849388,61.036022 
   C63.861881,61.158905 61.171143,63.725468 61.045029,69.609718 
   C60.874165,77.581696 60.891251,85.562477 61.053085,93.534912 
   C61.141144,97.872871 63.755733,100.734283 67.975632,100.896324 
   C76.603249,101.227585 85.254639,101.110641 93.891815,100.945999 
   C97.855888,100.870438 100.990723,97.377388 100.989342,93.676903 
   C100.986740,86.673393 100.990784,79.669891 100.995667,71.714188 
z"
            />
            <path
                fill="#FEFFFF"
                opacity="1.000000"
                stroke="none"
                d="
M100.993866,72.190285 
   C100.990784,79.669891 100.986740,86.673393 100.989342,93.676903 
   C100.990723,97.377388 97.855888,100.870438 93.891815,100.945999 
   C85.254639,101.110641 76.603249,101.227585 67.975632,100.896324 
   C63.755733,100.734283 61.141144,97.872871 61.053085,93.534912 
   C60.891251,85.562477 60.874165,77.581696 61.045029,69.609718 
   C61.171143,63.725468 63.861881,61.158905 69.849388,61.036022 
   C76.659164,60.896263 83.474007,60.995312 90.286629,61.003628 
   C98.704948,61.013905 100.986076,63.301563 100.993866,72.190285 
z"
            />
        </svg>
    )
}
export function ClearIcon() {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            viewBox="0 0 128 144"
            enable-background="new 0 0 128 144"
        >
            <path
                fill="none"
                opacity="1.000000"
                stroke="none"
                d="
M68.000000,145.000000 
   C45.333332,145.000000 23.166666,145.000000 1.000000,145.000000 
   C1.000000,97.000000 1.000000,49.000000 1.000000,1.000000 
   C43.666668,1.000000 86.333336,1.000000 129.000000,1.000000 
   C129.000000,49.000000 129.000000,97.000000 129.000000,145.000000 
   C108.833336,145.000000 88.666664,145.000000 68.000000,145.000000 
M50.372189,129.047882 
   C62.240543,133.597931 74.313812,133.924225 86.527168,130.705322 
   C107.662834,125.134872 127.768730,101.731308 126.950523,75.808266 
   C126.230904,53.008533 110.257965,30.596958 89.064743,24.186813 
   C67.136375,17.554316 47.474503,21.524094 30.926220,38.220650 
   C15.473464,53.811863 11.986310,72.445496 17.503359,92.868767 
   C22.118643,109.953850 33.767643,121.426285 50.372189,129.047882 
z"
            />
            <path
                fill="#000"
                opacity="1.000000"
                stroke="#fff"
                d="
M60.609489,59.361298 
   C70.993729,69.719460 70.993973,69.719711 81.031952,59.731178 
   C81.975395,58.792381 82.933731,57.867405 83.849686,56.902344 
   C86.415352,54.199112 89.412117,51.777107 92.785294,55.015301 
   C96.494957,58.576519 93.624512,61.609802 90.941055,64.307358 
   C88.124619,67.138588 85.423752,70.106262 82.418198,72.722267 
   C78.896164,75.787819 79.220932,78.342384 82.527237,81.323082 
   C85.858902,84.326630 88.880363,87.672737 92.065254,90.841095 
   C94.656624,93.418991 95.504982,96.265053 92.817490,99.148056 
   C89.768761,102.418564 87.191055,100.402969 84.790565,97.998947 
   C81.263329,94.466499 77.608620,91.052681 74.226372,87.387039 
   C71.802101,84.759636 69.915939,85.097404 67.632774,87.512260 
   C64.204941,91.137817 60.582623,94.579483 57.043427,98.099777 
   C54.655556,100.474907 51.876297,101.640694 49.184727,99.010956 
   C46.342182,96.233711 47.377563,93.337654 49.950874,90.782425 
   C53.374557,87.382805 56.661972,83.839058 60.195000,80.558693 
   C62.908421,78.039322 62.759563,75.899345 60.204170,73.438164 
   C56.729382,70.091469 53.388752,66.605705 49.980099,63.190052 
   C47.566082,60.771069 45.654125,58.143921 48.861778,55.126171 
   C51.763386,52.396351 54.609943,53.403297 57.149857,55.972942 
   C58.202293,57.037708 59.290207,58.067410 60.609489,59.361298 
z"
            />
        </svg>
    )
}
export function ChevronDown() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path
                fill-rule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
        </svg>
    )
}
export function ChevronUp() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path
                fill-rule="evenodd"
                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
            />
        </svg>
    )
}
